import styled from 'styled-components';

export const ProfileAuthWrapper = styled.div`
    display: flex;
    gap: 8px;
    flex-basis: max-content;
`;
